import { AddCircleOutlineOutlined } from '@mui/icons-material';
import {
  Box,
  Button,
  CardContent,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import store, { RootState } from '../../store/store';
import { createApprovalFlow } from '../../store/api/approval';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { Link as RouteLink } from 'react-router-dom';

const ApprovalPage = () => {
  const [approvalData, setApprovalData] = useState<{
    approvalType: string;
    approvalItems: [
      {
        seqId: number | null;
        approvalName: string;
        roles: string[];
        requiredApprovalCount: number | null;
      }
    ];
  }>({
    approvalType: 'RFQ_APPROVAL',
    approvalItems: [
      {
        seqId: null,
        approvalName: '',
        roles: [],
        requiredApprovalCount: null,
      },
    ],
  });

  const approvalItem: {
    seqId: number | null;
    approvalName: string;
    roles: string[];
    requiredApprovalCount: number | null;
  } = {
    seqId: null,
    approvalName: '',
    roles: [],
    requiredApprovalCount: null,
  };

  const storeApprovalState = useSelector((state: RootState) => state.approval);

  const handleChangeItems = (event: any, fieldName: string, index: number) => {
    let eventValue: any;
    if (fieldName === 'seqId' || fieldName === 'requiredApprovalCount') {
      eventValue = +event.target.value;
    } else {
      eventValue = event.target.value;
    }
    setApprovalData((preState: any) => {
      return {
        ...preState,
        approvalItems: [
          ...preState.approvalItems.slice(0, index),
          { ...preState.approvalItems[index], [fieldName]: eventValue },
          ...preState.approvalItems.slice(index + 1),
        ],
      };
    });
  };

  const addapprovalItems = () => {
    setApprovalData((preState: any) => {
      return {
        ...preState,
        approvalItems: [...preState.approvalItems, approvalItem],
      };
    });
  };

  const createApprovalData = () => {
    const reqBody = approvalData;
    store.dispatch(createApprovalFlow(reqBody)).then((res) => {
      if (res.payload !== 200) {
        console.log('successfully added approval');
      }
    });
  };
  console.log('ApprovalPage Rendered');
  // console.log('Approval Data:', approvalData);
  // console.log('Store Approval State:', storeApprovalState);
  return (
    <Box width={'100%'} marginLeft={'30px'}>
      <CardContent className='signinContent' sx={{ p: 0, pt: 0.5 }}>
        <Typography variant='h5'>Approval Page</Typography>
      </CardContent>

      <FormControl sx={{ width: 250, mt: 2 }} size='small'>
        <Select
          id='approvalType'
          value={approvalData.approvalType}
          onChange={(event) => {
            setApprovalData((preState) => {
              return {
                ...preState,
                approvalType: event.target.value as string,
              };
            });
          }}
        >
          <MenuItem value={'RFQ_APPROVAL'}>RFQ Approval</MenuItem>
          <MenuItem value={'QUOTE_APPROVAL'}>Quote Approval</MenuItem>
        </Select>
      </FormControl>

      <Box display={'flex'} gap={1} sx={{ width: '90%', mt: 2, mb: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={2}>
            <Typography flex={1} variant='body2' color={'#707070'}>
              Seq ID
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography flex={1} variant='body2' color={'#707070'}>
              Approval Name
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography flex={1} variant='body2' color={'#707070'}>
              Roles
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography flex={1} variant='body2' color={'#707070'}>
              Required Approval Count
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box
        display={'flex'}
        flexDirection={'column'}
        gap={2}
        sx={{ maxHeight: '432px', overflow: 'auto' }}
      >
        {approvalData.approvalItems.map((approval, ind) => (
          <Box display={'flex'} gap={1} key={ind}>
            <Box sx={{ width: '90%' }}>
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    id='seqId'
                    placeholder='Sequence ID'
                    size='small'
                    value={approval.seqId}
                    onChange={(e: any) => {
                      handleChangeItems(e, 'seqId', ind);
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Select
                    fullWidth
                    size='small'
                    id='approvalName'
                    value={approval.approvalName}
                    onChange={(e: any) => {
                      handleChangeItems(e, 'approvalName', ind);
                    }}
                  >
                    <MenuItem value={'L1 Approval'}>L1 Approval</MenuItem>
                    <MenuItem value={'L2 Approval'}>L2 Approval</MenuItem>
                    <MenuItem value={'L3 Approval'}>L3 Approval</MenuItem>
                    <MenuItem value={'L4 Approval'}>L4 Approval</MenuItem>
                    <MenuItem value={'L5 Approval'}>L5 Approval</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    id='approvalName'
                    value={approval.roles}
                    multiple
                    onChange={(e: any) => {
                      handleChangeItems(e, 'roles', ind);
                    }}
                  >
                    <MenuItem value={'SOCIETY_ADMIN'}>Organization Admin</MenuItem>
                    <MenuItem value={'SOCIETY_MEMBER'}>Organization Member</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    id='requiredApprovalCount'
                    placeholder='Required Approval Count'
                    size='small'
                    value={approval.requiredApprovalCount}
                    onChange={(e: any) => {
                      handleChangeItems(e, 'requiredApprovalCount', ind);
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
            {approvalData.approvalItems.length === ind + 1 && ind + 1 !== 5 && (
              <AddCircleOutlineOutlined
                onClick={addapprovalItems}
                fontSize='large'
                color='primary'
              />
            )}
          </Box>
        ))}
      </Box>

      <Box display={'flex'} gap={3} sx={{ mt: 2 }}>
        {/* <FormControl>
          <RouteLink to='/dashboard'>
            <Button
              variant='outlined'
              sx={{ borderRadius: 20, fontWeight: 'bold' }}
            >
              BACK
            </Button>
          </RouteLink>
        </FormControl> */}
        <FormControl>
          <LoadingButton
            loading={storeApprovalState.loading}
            loadingPosition='center'
            variant='contained'
            sx={{ borderRadius: 20, fontWeight: 'bold' }}
            onClick={createApprovalData}
          >
            Create
          </LoadingButton>
        </FormControl>
      </Box>
    </Box>
  );
};
export default ApprovalPage;
